import { Markdown } from '@/components/ui/smoothdown';
import { cn } from '@/lib/utils';

import { useElementId } from '../fieldIds';
import { ClampedText } from '../internals/ClampedText';
import { MrkdwnText } from '../internals/MrkdwnText';
import {
  MARKDOWN_CLASS,
  MARKDOWN_TONE_CLASS,
  sizingClass,
  TEXT_STYLE,
  TONE_CLASS,
} from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

export const Body: ComponentFn<typeof catalog, 'Body'> = ({ props }) => {
  const id = useElementId(props);
  if (!props.text) return null;
  const textClass = cn(
    TEXT_STYLE[props.textStyle ?? 'body'],
    TONE_CLASS[props.tone ?? 'default']
  );

  const content =
    props.format === 'markdown' ? (
      <Markdown
        id={id}
        content={props.text}
        className={cn(
          MARKDOWN_CLASS,
          textClass,
          props.tone && MARKDOWN_TONE_CLASS[props.tone]
        )}
      />
    ) : props.format === 'mrkdwn' ? (
      <p className={cn('min-w-0', textClass)}>
        <MrkdwnText text={props.text} />
      </p>
    ) : (
      <p className={cn('min-w-0 whitespace-pre-wrap break-words', textClass)}>
        {props.text}
      </p>
    );

  return (
    <ClampedText
      lines={props.lines}
      className={cn('min-w-0', sizingClass(props.sizing))}
    >
      {content}
    </ClampedText>
  );
};
